import React, { Component } from 'react';
import { classnames, classname } from 'utils';
import { Counter } from 'components';
import { Icon } from 'elements';

import './Footer.css';

class Footer extends Component {
  cl = classname('footer');

  render() {
    const { className } = this.props;

    const classes = classnames(className, this.cl());

    return (
      <footer className={classes}>

          <div className={this.cl('legend')}>
            <div className={this.cl('top')}>
              <div className={this.cl('title')}>Обозначения</div>
              <div className={this.cl('copyright')}>© AdIndex</div>
            </div>

            <div className={this.cl('legend-item')}>
              <div className={this.cl('legend-counter')}>
                <Counter>9.9</Counter>
              </div>
              <div className={this.cl('legend-text')}>Балл в&nbsp;интегральном рейтинге Technology Index 2020</div>
            </div>

            <div className={this.cl('legend-item')}>
              <div className={this.cl('legend-star')}>
                <Icon name={'star'} />
              </div>
              <div className={this.cl('legend-text')}>Партнёр проекта</div>
            </div>
          </div>
      </footer>
    );
  }
}

export default Footer;
